// @flow
import React from 'react';

import Content from './Content';

const UserToolReports = props => {
  return <Content {...props} />;
};

export default UserToolReports;
